import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import {
  tannerBlack,
  tannerGray,
  tannerSemantic,
  tannerWhite,
} from '../colors';

type MuiInputBase = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiInputBase'];
  defaultProps?: ComponentsProps['MuiInputBase'];
  variants?: ComponentsVariants['MuiInputBase'];
};

type MuiInput = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiInput'];
  defaultProps?: ComponentsProps['MuiInput'];
  variants?: ComponentsVariants['MuiInput'];
};

type MuiFilledInput = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiFilledInput'];
  defaultProps?: ComponentsProps['MuiFilledInput'];
  variants?: ComponentsVariants['MuiFilledInput'];
};

type MuiInputLabel = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiInputLabel'];
  defaultProps?: ComponentsProps['MuiInputLabel'];
  variants?: ComponentsVariants['MuiInputLabel'];
};

export const MuiInputBase: MuiInputBase = {
  styleOverrides: {
    root: {
      backgroundColor: tannerWhite,
      '&:hover': {
        borderColor: tannerBlack,
      },
    },
    input: {
      fontSize: 14,
    },
  },
};

export const MuiInput: MuiInput = {
  defaultProps: {
    disableUnderline: true,
  },
};

export const MuiFilledInput: MuiFilledInput = {
  defaultProps: { disableUnderline: true },
  styleOverrides: {
    root: {
      backgroundColor: tannerWhite,
      paddingRight: 8,
      '&:hover': {
        backgroundColor: tannerWhite,
        borderColor: '#000',
      },
      '&.Mui-disabled': {
        backgroundColor: tannerGray['50'],
        color: tannerGray['400'],
        WebkitTextFillColor: tannerGray['400'],
      },
    },
    adornedStart: {
      paddingLeft: 16,
    },
    inputAdornedStart: {
      paddingLeft: 0,
    },
    inputAdornedEnd: {
      paddingRight: 16,
    },
    input: {
      paddingLeft: 16,
    },
    inputMultiline: {
      paddingLeft: 4,
    },
  },
};

export const MuiInputLabel: MuiInputLabel = {
  styleOverrides: {
    root: {
      color: tannerGray['600'],
      fontWeight: 500,
      '&.Mui-error,&.Mui-error.Mui-focused': {
        color: tannerSemantic.error.color,
      },
      '&.Mui-focused': {
        color: tannerGray['600'],
      },
      '&.Mui-disabled': {
        color: tannerGray['400'],
      },
    },
    filled: {
      maxWidth: '65%',
      color: tannerGray['600'],
      fontWeight: 500,
      transform: 'translate(17px, 20px) scale(1)',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(17px, 12px) scale(.8)',
        maxWidth: '100%',
      },
      '&.MuiInputLabel-sizeSmall': {
        transform: 'translate(17px, 16px) scale(1)',
        '&.MuiInputLabel-shrink': {
          transform: 'translate(17px, 8px) scale(.8)',
          maxWidth: '100%',
        },
      },
    },
    outlined: {
      color: tannerGray['600'],
      fontWeight: 500,
      transform: 'translate(17px, 20px) scale(1)',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(17px, -6px) scale(.8)',
        maxWidth: '100%',
      },
      '&.MuiInputLabel-sizeSmall': {
        transform: 'translate(17px, 11px) scale(1)',
        '&.MuiInputLabel-shrink': {
          transform: 'translate(17px, -6px) scale(.8)',
          maxWidth: '100%',
        },
      },
    },
  },
};
